export class Image {
    id?: number;
    name: string;
    href?: string;
    size?: number;
    primary?: boolean;
    thumbHref?: string;

    constructor(
        id?: number,
        name: string = '',
        href?: string,
        size?: number,
        primary?: boolean,
        thumbHref?: string
    ) {
        this.id = id;
        this.name = name;
        this.href = href;
        this.size = size;
        this.primary = primary;
        this.thumbHref = thumbHref;
    }
}